import {Rule} from '@/Types/SchemaField';

class RulesTransformer {
    rules: (string | Rule)[];

    constructor(rules: string | Rule[]) {
        let _rules = rules;
        if (typeof _rules === 'string') {
            _rules = _rules.split('|');
        }

        this.rules = _rules;
    }

    getTransformed(): Rule[] {
        return this.rules.map(this.transformRule)
    }

    transformRule(rule: Rule): Rule {
        if (typeof rule === 'string') {
            switch (rule) {
                case 'nullable':
                    return 'optional';

                case 'numeric':
                case 'integer':
                    return 'number';

                default:
                    if (rule.match(/^required_/)) {
                        return 'required';
                    }
            }
        }

        return rule;
    }

}

export default RulesTransformer;
